import {AccountBalanceWalletOutlined} from "@mui/icons-material";
import ManageUserAccount from "@mui/icons-material/ManageAccountsOutlined";
import {
  Button,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from "@mui/material";
import {
  AccountPopoverFooter,
  AccountPreview,
  SignOutButton,
} from "@toolpad/core/Account";
import {type FC} from "react";

type MenuProps = {
  handleOpenResetPassword: () => void;
  handleOpenTopUp: () => void;
};
const Menu: FC<MenuProps> = props => {
  const {handleOpenResetPassword, handleOpenTopUp} = props;

  return (
    <>
      <Stack direction="column">
        <AccountPreview variant="expanded" />

        <Divider />

        <Typography variant="body2" mx={2} mt={1}>
          Account Menu
        </Typography>

        <MenuList>
          <MenuItem component={Button} onClick={handleOpenResetPassword}>
            <ListItemIcon>
              <ManageUserAccount fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Reset Password"
              slotProps={{primary: {sx: {textTransform: "none"}}}}
            />
          </MenuItem>

          <MenuItem component={Button} onClick={handleOpenTopUp}>
            <ListItemIcon>
              <AccountBalanceWalletOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Top Up Account"
              slotProps={{primary: {sx: {textTransform: "none"}}}}
            />
          </MenuItem>
        </MenuList>

        <Divider />

        <AccountPopoverFooter>
          <SignOutButton />
        </AccountPopoverFooter>
      </Stack>
    </>
  );
};

export default Menu;
